<template lang="pug">
        v-flex(xs12 class="m-block-form-links")
            v-layout(wrap justify-center)
                v-flex(xs12 class="text-xs-center py-0" v-for="(link, index) in links" :key="index")
                    e-link-item(@click="redirect(link.route.name)" @keyup.enter="redirect(link.route.name)") {{ link.text }}

                    e-divider-secondary(v-if="index !== (links.length - 1)")
</template>

<script>
    export default {
        name: "m-block-form-links",
        props: {
            links: {
                type: Array,
                required: true
            },
        },
    }
</script>

<style lang="scss" scoped>
    .m-block-form-links {
        margin-top: 22px;
    }
</style>
